









import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from 'vue-property-decorator'

@Component({components: {}})
export default class FilterSelectedItemWings extends Vue {
  @Prop(String) label!: string;
  @Prop() value!: any;

  get isEmpty():boolean{
    if (Array.isArray(this.value)) return Boolean(this.value.length);
    return Boolean(this.value);
  }
}
